<template>
  <div
    class="opacity-50 duration-300"
    :class="{
      'fixed inset-y-0 left-0 z-20 h-full w-full bg-black ': modelValue,
      'opacity-0': !modelValue
    }"
  />
  <div
    class="fixed inset-y-0 left-0 flex h-full w-full items-center justify-center overflow-y-auto transition-all duration-300"
    :class="{
      'z-20 translate-y-0 opacity-100': modelValue,
      'z-10 translate-y-full opacity-0': !modelValue
    }"
  >
    <slot name="body" />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ComponentsModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  }
});
</script>